"use strict";import{css as t}from"lit";const e=t`.cu-badge{width:31.4375rem}`;export default e;
//# sourceMappingURL=badge.css.js.map
